import { createBasicSelector } from "@store/shared/selectors"
import { createSelector } from "reselect"
import { fetchUserOrgs } from "./actionSets"

export const getOrganisations = createBasicSelector((state) => state.organisations.orgs)

export const hasOrganisations = createSelector([getOrganisations], (organisations) => {
	return organisations.length > 0
})

export const areOrganisationsLoading = createBasicSelector(
	(state) => state.organisations.requests[fetchUserOrgs.request].isLoading
)
